module.exports = __webpack_public_path__ + "img/calendar2-fill.e3a46f70.svg";